import PageHeader from "./page-header";
import PageContent from "./page-content";
import PageTop from './page-top';
import StickyContainer from "../../layout/sticky-container";

export default function Page({ header, content, top }) {
    return (
        <div className="state-pages">
            { top !== null && <PageTop>{ top }</PageTop>}
            { header !== null && <StickyContainer>{header}</StickyContainer>  }
            { content !== null && <PageContent>{ content }</PageContent> }
        </div>
    )
}
